import axios from "axios";
import { DealResponse, EmployeeDealsResponse} from "./dto/Deal";

// 取引情報取得
export const getDeal = async (dealId: string): Promise<DealResponse> => {
  const res = await axios.get<DealResponse>(`/api/users/deal?id=${dealId}`, {
    headers: { "Content-Type": "application/json;charset=utf-8" },
  });
  return res.data;
};